
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getGetMailsAndPhonesDtoFormGroup() {
return new FormGroup({
    appAccessCode: new FormControl<string | undefined>(''),
    contactId: new FormControl<number | undefined>(undefined),
})
;
}
      